import {PageStandard} from "../utils/PageStandard";
import {Card, Grid, Stack, Typography} from "@mui/joy";
import { Category, Construction, Group, Label, Map, Translate } from "@mui/icons-material";
import { Link } from "react-router-dom";


export function Home() {
    return (
        <PageStandard title="Home" sidebarVisible={true}>
            <Typography level="title-md">Comandi rapidi</Typography>
            <Grid container spacing={2}>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Link to="/categorie">
                        <Card size="lg" sx={{width:"100%", minHeight:"10rem"}} className="hoverScale">
                            <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                                <Typography level="h2">
                                    <Category />
                                </Typography>
                                <Typography level="h2">Categorie</Typography>
                            </Stack>
                        </Card>
                    </Link>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Link to="/servizi">
                        <Card size="lg" sx={{width:"100%", minHeight:"10rem"}} className="hoverScale">
                            <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                                <Typography level="h2">
                                    <Label />
                                </Typography>
                                <Typography level="h2">Servizi</Typography>
                            </Stack>
                        </Card>
                    </Link>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Link to="/mappa">
                        <Card size="lg" sx={{width:"100%", minHeight:"10rem"}} className="hoverScale">
                            <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                                <Typography level="h2">
                                    <Map />
                                </Typography>
                                <Typography level="h2">Mappa</Typography>
                            </Stack>
                        </Card>
                    </Link>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Link to="/utenti">
                        <Card size="lg" sx={{width:"100%", minHeight:"10rem"}} className="hoverScale">
                            <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                                <Typography level="h2">
                                    <Group />
                                </Typography>
                                <Typography level="h2">Utenti</Typography>
                            </Stack>
                        </Card>
                    </Link>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Link to="/traduzioni">
                        <Card size="lg" sx={{width:"100%", minHeight:"10rem"}} className="hoverScale">
                            <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                                <Typography level="h2">
                                    <Translate />
                                </Typography>
                                <Typography level="h2">Traduzioni</Typography>
                            </Stack>
                        </Card>
                    </Link>
                </Grid>
                <Grid xs={12} md={4} sx={{width:"100%"}}>
                    <Link to="/impostazioni">
                        <Card size="lg" sx={{width:"100%", minHeight:"10rem"}} className="hoverScale">
                            <Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
                                <Typography level="h2">
                                    <Construction />
                                </Typography>
                                <Typography level="h2">Impostazioni</Typography>
                            </Stack>
                        </Card>
                    </Link>
                </Grid>
            </Grid>
        </PageStandard>
    )
}